export default __webpack_public_path__ + "static/char-s-10-jp-556f84cc0e2d2db0feada33fb626e3cc.png";